import { render, staticRenderFns } from "./AwaitingTickets.vue?vue&type=template&id=54525aff"
import script from "./AwaitingTickets.vue?vue&type=script&lang=js"
export * from "./AwaitingTickets.vue?vue&type=script&lang=js"
import style0 from "./AwaitingTickets.vue?vue&type=style&index=0&id=54525aff&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports